import type { ComponentPropsWithRef, ReactNode } from 'react';

import { clsx } from '~/styles/utils';

import { JobPostCardSkeleton } from './JobPostCardSkeleton';
import { listResponsiveStyle, listStyle } from './JobPostsList.css';

type Props = ComponentPropsWithRef<'ul'> & {
  children: ReactNode;
  isLoading?: boolean;
  length?: number;
  responsive?: boolean;
};

export const JobPostsList = ({ children, isLoading, length = 10, responsive = true, ...delegated }: Props) => {
  return (
    <ul {...delegated} aria-busy={isLoading} className={clsx(listStyle, responsive && listResponsiveStyle, delegated.className)}>
      {isLoading && Array.from({ length }, () => null).map((_, i) => <JobPostCardSkeleton key={i} />)}
      {!isLoading && children}
    </ul>
  );
};
